<template>
  <j-select
    v-if="$vuetify.breakpoint.xsOnly"
    multiple
    :class="{ 'no-before': noBefore }"
    combo-box
    chips
    simple-item
    :solo="solo"
    :filled="filled"
    :dense="dense"
    hashtag
    :prepend-inner-icon="icon"
    :solo-inverted="soloInverted"
    :hide-details="hideDetails"
    :items="getUniqueTags"
    :value="value"
    label="Mots clés"
    @change="onChange"
  ></j-select>
  <v-combobox
    v-else
    multiple
    chips
    deletable-chips
    :class="{ 'no-before': noBefore }"
    :solo="solo"
    :prepend-inner-icon="icon"
    :solo-inverted="soloInverted"
    :hide-details="hideDetails"
    :filled="filled"
    :dense="dense"
    :items="getUniqueTags"
    :value="value"
    :label="label"
    autocomplete="off"
    :search-input.sync="searchInput"
    @change="onChange"
  ></v-combobox>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RecipeProductTagsEditor",
  props: {
    value: {
      type: Array,
      required: true
    },
    solo: {
      type: Boolean,
      default: true
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    filled: {
      type: Boolean,
      default: false
    },
    noBefore: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "Mots Clés"
    },
    icon: {
      type: String,
      default: "fa-hashtag"
    }
  },
  computed: {
    ...mapGetters([
      "getProducts",
      "getRecipes",
      "getOrganisationId",
      "getStoreId",
      "getTagCategories"
    ]),
    getUniqueTags() {
      return [
        ...new Set([
          ...this.getRecipes
            .filter(x => x.data !== null)
            .map(x => x.data.tags)
            .flat(),
          ...this.getProducts
            .filter(x => x.data !== null)
            .map(x => x.data.tags)
            .flat(),
          ...this.getTagCategories.map(x => x.tags).flat()
        ])
      ];
    }
  },
  data() {
    return {
      searchInput: ""
    };
  },
  methods: {
    onChange(v) {
      this.searchInput = "";
      if (v.length > 0 && v.slice(-1)[0].charAt(0) === "#") {
        this.$emit("input", v);
      } else if (v.length > 0 && v.slice(-1)[0].charAt(0) !== "#") {
        v[v.length - 1] = `#${v.slice(-1)[0]}`;
        this.$emit("input", v);
      } else {
        this.$emit("input", v);
      }
    }
  }
};
</script>

<style></style>
